import { CLEAR_PAGE } from '../base/types';
import { DELETE_PAGES, FETCH_PAGES } from './types';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  data: [],
};

const pagesReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_PAGES}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_PAGES}_FULFILLED`:
      return {
        ...state,
        data: payload,
        isLoaded: true,
        isLoading: false,
      };
    case `${FETCH_PAGES}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };
    case `${DELETE_PAGES}_FULFILLED`:
      return {
        ...state,
        data: state.data.filter((i) => Number(i.id) !== Number(payload?.id)),
      };

    case CLEAR_PAGE:
      return payload === 'pages' ? INIT_STATE : state;

    default:
      return state;
  }
};

export default pagesReducer;
